module.exports = __webpack_public_path__ + "img/meet-bulletin.5812bb16.svg";